export const SwipeSlider = function() {
    const homepageHeaderSlider = document.getElementById('homepageHeaderSlider');
    if(homepageHeaderSlider) {
        window.mySwipe = new Swipe(homepageHeaderSlider, {
            startSlide: 0,
            auto: 5000,
            draggable: false,
            autoRestart: false,
            continuous: true,
            disableScroll: true,
            stopPropagation: true,
            callback: function (index, element) {
            },
            transitionEnd: function (index, element) {
            }
        });
    }
}